import Debouncer from '../lib/Debouncer';

// To test on homepage, add .entryIntro__media { max-height: 500px; min-height: 0; } 
// To test on 2020 Greeting, add .holidayGreeting__media { max-height: 500px; }
// (otherwise only largest video is served)

const entryVideo = (selector: string) => {
	const container = document.querySelector(selector);
	if (!container) return;
	const video = container.querySelector('video');
	if (!video) return;
	const sources = video.querySelectorAll('source');

	type VideoSourceData = { element: HTMLSourceElement, width: number, height: number };
	const sourcesData = new Array<VideoSourceData>();
	let containerBoundingRect = container.getBoundingClientRect();
	let containerWidth = containerBoundingRect.width;
	let containerHeight = containerBoundingRect.height;

	for (let i = 0, l = sources.length; i < l; ++i) {
		const width = parseInt(sources[i].dataset.width);
		const height = parseInt(sources[i].dataset.height);

		sourcesData.push({
			element: sources[i],
			width: width,
			height: height
		});
	}

	// Sort ascending
	sourcesData.sort((a, b) => a.width - b.width);

	let playPromise;
	const playVideo = (index: number) => {
		let element = sourcesData[index].element;
		video.src = element.dataset.src;
		playPromise = video.play();
		playPromise.catch(() => {
			// Code to deal with: Uncaught (in promise) DOMException: The play() request was interrupted by a call to pause().
			// https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
			// poof console error gone.
		});
	}

	let currentSourceIndex: number;
	let currentSource: VideoSourceData;
	const largestVideoSourceIndex = sourcesData.length - 1;

	for (let i = 0, l = sourcesData.length; i < l; ++i) {
		if ((sourcesData[i].width >= containerWidth && sourcesData[i].height >= containerHeight) || i === largestVideoSourceIndex) {
			currentSourceIndex = i;
			currentSource = sourcesData[currentSourceIndex];
			playVideo(i);
			break;
		}
	}
	
	// Only update video on resize if it will be bigger than current one
	if (currentSourceIndex !== largestVideoSourceIndex) {
		let nextSourceIndex = currentSourceIndex + 1;

		const resizeDebouncer = new Debouncer(() => {
			containerBoundingRect = container.getBoundingClientRect();
			containerWidth = containerBoundingRect.width;
			containerHeight = containerBoundingRect.height;

			if (currentSource.width < containerWidth || currentSource.height < containerHeight) {
				video.load();
				playVideo(nextSourceIndex);
				
				if (nextSourceIndex === largestVideoSourceIndex) {
					window.removeEventListener('resize', resizeDebouncer.run);
				}

				currentSourceIndex++;
				currentSource = sourcesData[currentSourceIndex];
				nextSourceIndex++;
				return;
			}

		});
		window.addEventListener('resize', resizeDebouncer.run);
	}
}
export default entryVideo;